/**
 * @generated SignedSource<<dc0ce8343041058e5dc6f90f2eed8b7a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AddServiceOptionDialog_service$data = {
  readonly id: string;
  readonly " $fragmentType": "AddServiceOptionDialog_service";
};
export type AddServiceOptionDialog_service$key = {
  readonly " $data"?: AddServiceOptionDialog_service$data;
  readonly " $fragmentSpreads": FragmentRefs<"AddServiceOptionDialog_service">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AddServiceOptionDialog_service",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Service",
  "abstractKey": null
};

(node as any).hash = "f8a128cb4460ef1998cfe12dc819ce90";

export default node;
